import React from 'react';

import BlockAccessPage from '../../../../../components/BlockAccess/BlockAccessPage';
import {checkIfHasPermissions} from '../../../../../components/Menu/Utils/commonFunctions';
import B2BTable from '../../../../../components/Table/B2BTable';
import Tabs from '../../../../../components/Tabs/Tabs';
import {PermissionEnum} from '../../../../../constants/permissionsEnum';
import TranslatedText from '../../../../../libraries/I18N/TranslatedText';
import {accessModule} from '../../../../../store/companyStore/companyDetailsStore';
import {shouldBlockModuleAccess} from '../../../../../utils/SubscriptionHelper';

const Processing: React.FC<{
  selectedYear: string;
}> = ({selectedYear}) => {
  const B2bTabs = [
    {
      id: 'rawAverage',
      name: <TranslatedText translationKey="Average" />,
      component: shouldBlockModuleAccess(accessModule.scope3) ? (
        <BlockAccessPage />
      ) : (
        <B2BTable selectedYear={selectedYear} isAverage="Average" />
      ),
      hidden: !checkIfHasPermissions(
        PermissionEnum.OrgManagerProductProcessingOfSoldProductAverage
      )
    },
    {
      id: 'rawSupplier',
      name: <TranslatedText translationKey="Supplier Specific" />,
      component: shouldBlockModuleAccess(accessModule.scope3) ? (
        <BlockAccessPage />
      ) : (
        <B2BTable selectedYear={selectedYear} isAverage="Supplier" />
      ),
      hidden: !checkIfHasPermissions(
        PermissionEnum.OrgManagerProductProcessingOfSoldProductSupplierSpecific
      )
    }
  ].filter((item) => !item.hidden);

  return <Tabs array={B2bTabs} type="card" />;
};

export default Processing;
